/** Bitbucket commit SHA baked at CI time; "dev" locally so the update banner stays quiet. */
export const BITBUCKET_COMMIT: string =
  process.env.REACT_APP_BITBUCKET_COMMIT || 'dev';

export type VersionPayload = {
  version: string;
};

export function isUpdateAvailable(
  currentCommit: string,
  remoteVersion: string | null | undefined
): boolean {
  if (!remoteVersion || currentCommit === 'dev') {
    return false;
  }
  return remoteVersion !== currentCommit;
}
